<template >
    <div v-if="$page.props.products.length" class="row pt-4">

        <div class="col-6 col-md-4 col-xl-3 mb-4 p-2 p-lg-2 hvr-float" v-for="product in $page.props.products" :key="product.id">
            <inertia-link class="bg-white h-100  shadow-sm d-block" :href="route('product',{id:product.id})">
                <img :srcset="product.product_cover_image" class="img-fluid" style="height:300px;width:100%;object-fit:contain;object-position: center"/>
                <br/>
                
                <div class="p-3">
                <p style="line-height:initial;">{{product.short_name}}</p>
                <p><b>{{$page.props.currency}} {{product.price_range}}</b></p>
                </div>
            </inertia-link>
        </div>



        <paginator/>
    </div>
    <div v-else class="bg-light p-5 text-center">
       <div v-if="$page.props.search">
           Product not found..
       </div>
       <div v-else>
            We are updating the product..
       </div>
    </div>
    
</template>



<script>
    import Paginator from '@/Layouts/Paginator'
    export default {
        components: {
            Paginator,
        },
         props:{
            "products":Array
        }
    }
</script>